import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetCommentCountQueryVariables = Types.Exact<{
  assetId: Types.Scalars['ID']['input'];
}>;


export type GetCommentCountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, asset?: { __typename?: 'AudioAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'DocumentAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'FileAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'FolderAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'ImageAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'InteractiveAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'InteractiveLiveAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'ModelAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'UnsupportedAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'VersionStackAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | { __typename?: 'VideoAsset', id: string, commentCount?: number | null, commentCountStats?: { __typename?: 'CommentCountStats', private?: number | null, public?: number | null } | null } | null } | null };


export const GetCommentCount = /*#__PURE__*/ gql`
    query GetCommentCount($assetId: ID!) {
  account(by: {assetId: $assetId}) {
    id
    asset(id: $assetId) {
      id
      commentCount
      commentCountStats {
        private
        public
      }
    }
  }
}
    ` as unknown as DocumentNode<GetCommentCountQuery, GetCommentCountQueryVariables>;

          

          export const useGetCommentCountQuery = (options?:QueryHookOptions<GetCommentCountQuery, GetCommentCountQueryVariables>) => useQuery(GetCommentCount, options);

          

          export type GetCommentCountQueryOptions = QueryHookOptions<GetCommentCountQuery, GetCommentCountQueryVariables>;

          

          export const useGetCommentCountLazyQuery = (options?:LazyQueryHookOptions<GetCommentCountQuery, GetCommentCountQueryVariables>) => useLazyQuery(GetCommentCount, options);

          

          export type GetCommentCountQueryResult = ReturnType<typeof useGetCommentCountQuery>;

          
